import React from 'react'

export default class Video extends React.Component {

	constructor(props) {
		super(props)

		this.state = {
			id: `video-${Date.now()}-${Math.round(Math.random()*1000)}`
		}
	}

	componentDidMount() {
		const player = document.getElementById(this.state.id)
		player.addEventListener('mouseover', _ => player.pause())
		player.addEventListener('mouseout', _ => player.play())
	}

	render() {
		return (
			<video 
				id={this.state.id}
				autoPlay 
				loop 
				controls={false} 
				style={{maxWidth: '700px'}}
			>
				<source src={this.props.src} />
			</video>
		)
	}
}


// WEBPACK FOOTER //
// ./src/Video.js